import useGetMc from '@/hooks/useGetMc';

interface Props {
    mcUriId: string | undefined;
    children: any;
}

const GetMcContainer = ({ mcUriId, children }: Props) => {
    const { mc, isLoading } = useGetMc({
        mcUriId,
    });

    return children({ mc, isLoading });
};

export default GetMcContainer;
